import { assign, object, optional, pick, string } from 'superstruct';
import { PaginationQueryDefaulted, UnsafeSortQueryDefaulted } from '@arc/shared/util-data';
import { isoDateTimeWithCoercions, parsableArray, parsableBoolean, parsableInteger } from '@arc/shared/util-superstruct';
export const UserFilterDto = object({
  archived: optional(parsableBoolean()),
  loggedInAfter: optional(isoDateTimeWithCoercions()),
  loggedInBefore: optional(isoDateTimeWithCoercions()),
  search: optional(string()),
  /**
   * When this is non-empty, return only users with at least one of the specified roles.
   */
  roles: optional(parsableArray(parsableInteger()))
});
export const UserListFilterDto = assign(PaginationQueryDefaulted(10), UnsafeSortQueryDefaulted('name', 'asc'), UserFilterDto);
export const UserListFrontendFilterDto = pick(UserListFilterDto, ['archived', 'loggedInAfter', 'loggedInBefore']);